import React from "react";
import { Table, Button, Tag , Select, Row, Col , Popconfirm } from "antd";
import useTeamSkillValidation from "./logic/useTeamSkillValidation";
import "./TeamSkillValidation.scss";

const { Option } = Select;


const TeamSkillValidation = () => {
  const {
    skillsRequests,
    isLoading,
    approveSkillRequest,
    rejectSkillRequest,
    loadingAction,
    statusFilter,       
    setStatusFilter,     
  } = useTeamSkillValidation();
  

  const columns = [
    
    {
      title: "Requester",
      dataIndex: "user",
      key: "user",
      render: (user) =>
        user ? `${user.firstName} ${user.lastName}` : "Unknown Member",
    },
    {
      title: "Skill",
      dataIndex: "skill",
      key: "skill",
      render: (skill) => (skill ? skill.name : "Unknown Skill"),
    },
    {
      title: "Level",
      dataIndex: "level",
      key: "level",
      render: (level) => {
        const levelLabels = {
          1: "Beginner",
          2: "Intermediate",
          3: "Advanced",
          4: "Professional",
        };
        return levelLabels[level] || "Unknown";
      },
    },
    {
      title: "Status",
      dataIndex: "status",
      key: "status",
      render: (status) => (
        <>
          {status === "Approved" && <Tag color="green">Approved</Tag>}
          {status === "Pending" && <Tag color="blue">Pending</Tag>}
          {status === "Rejected" && <Tag color="red">Rejected</Tag>}
        </>
      ),
    },
    {
      title: "Actions",
      key: "actions",
      render: (record) => (
         <div className="action-buttons-wrapper">
          <Popconfirm
            title="Are you sure you want to approve this skill?"
            onConfirm={() => approveSkillRequest(record.id)}
            okText="Yes"
            cancelText="No"
            disabled={record.status === "Approved"}
          >
            <Button
              type="primary"
              disabled={record.status === "Approved" || loadingAction}
            >
              Validate
            </Button>
          </Popconfirm>
    
          <Popconfirm
            title="Are you sure you want to reject this skill?"
            onConfirm={() => rejectSkillRequest(record.id)}
            okText="Yes"
            cancelText="No"
            disabled={record.status === "Rejected" || record.status === "Approved"}
          >
            <Button
              danger
              disabled={
                record.status === "Rejected" ||
                record.status === "Approved" ||
                loadingAction
              }
              style={{ marginLeft: "10px" }}
            >
              Reject
            </Button>
          </Popconfirm>
        </div>
      ),
    }
    
  ];

  return (
      <div className="team-skill-validation">
      <Row style={{ marginBottom: 16 }}>
        <Col span={6}>
          <Select
            value={statusFilter}
            onChange={setStatusFilter}
            style={{ width: "100%" }}
          >
            <Option value="All">All</Option>
            <Option value="Pending">Pending</Option>
            <Option value="Rejected">Rejected</Option>
          </Select>
        </Col>
      </Row>

      <Table
        columns={columns}
        dataSource={skillsRequests}
        loading={isLoading}
        rowKey="id"
      />
   </div>
  );
};

export default TeamSkillValidation;
